import Big from 'big.js'
import { blockExplorerMap } from '../../services/provider-settings'

export const getBlockExplorerName = (network: number): string => blockExplorerMap[network]

export const transactionAmountFormatter = (amount: string) => {
  const currentAmount = Big(amount)
  if (currentAmount.precision(2).eq(0)) {
    return '<0.01'
  } else {
    return currentAmount.precision(2).toString()
  }
}
